"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Back = function Back(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.3 25.5",
    width: "29.3",
    height: "25.5"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.5,15.4C4.5,15.4,4.5,15.4,4.5,15.4c-0.3,0-0.5-0.1-0.6-0.3L0.1,9.4C-0.1,9,0,8.6,0.3,8.3c0.3-0.2,0.8-0.1,1,0.2 l3.2,4.9l3.8-4.3C8.7,8.8,9.1,8.8,9.5,9c0.3,0.3,0.3,0.7,0.1,1.1l-4.4,5.1C5,15.3,4.8,15.4,4.5,15.4z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17,25.5c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.8,0.7-0.8c3-0.1,5.8-1.4,7.8-3.6c2-2.2,3.1-5.1,3-8.1 c-0.1-3-1.4-5.8-3.6-7.8c-2.2-2-5.1-3.1-8.1-3c-3.1,0.1-5.9,1.4-7.9,3.7C6.1,7.6,5,11,5.3,14.6c0,0.4-0.3,0.8-0.7,0.8 c-0.4,0-0.8-0.3-0.8-0.7c-0.3-4,0.9-7.8,3.3-10.5c2.3-2.6,5.5-4.1,9-4.2c3.4-0.1,6.7,1.1,9.1,3.4c2.5,2.3,3.9,5.5,4.1,8.9 c0.1,3.4-1.1,6.7-3.4,9.1C23.6,23.9,20.4,25.4,17,25.5C17,25.5,17,25.5,17,25.5z"
  }));
};

var _default = Back;
exports["default"] = _default;